import React from 'react';
import '../App.css';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <h1>WE ARE INDIANS</h1>
      <p>WE WELCOME YOU ALL TO OUR WEBSITE</p>
    </div>
  );
}

export default HeroSection;
